import axios from './httpConfig.js'
//******************首页 ******************/
// 实时总库存及环比同步值
export function GetHomeStockViews(param) {
	return axios.post('/welcome/stock/views', param)
}

// 出入库 日变化 分析接口
export function GetHomeStockDay(param) {
	return axios.post('/welcome/receipt/issue/views/day', param)
}

// 出入库_排名_根据时间周期_接口
export function GetHomeStockSort(param) {
	return axios.post('/welcome/receipt/issue/views/top/bytime', param)
} 

// 出入库_月波动_近12个月_接口
export function GetHomeStockMonth(param) {
	return axios.post('/welcome/receipt/issue/views/month', param)
} 

// 实时 分库房总库存及环比同步值
export function GetHomeWareHouseViews(param) {
	return axios.post('welcome/stock/views/warehouse', param)
} 

// 出入库_根据时间周期和库房获取_分类占比
export function GetHomeSaleProportion(param) {
	return axios.post('/welcome/receipt/issue/views/proportion/bytime', param)
} 

// 交易客户数量
export function GetHomeCustomerCount(param) {
	return axios.post('/welcome/customer/views/count/byday', param)
} 

// 客户平均采购量
export function GetHomeDeal(param) {
	return axios.post('/welcome/customer/views/inoutcount/byday', param)
} 



